import React, { CSSProperties } from "react";
import { Button, ButtonProps, styled, SxProps, Theme } from "@mui/material";

export type TextProps = {
  small?: boolean;
  medium?: boolean;
  large?: boolean;
  larger?: boolean;
  children?: React.ReactNode;
  numeric?: boolean;
  normal?: boolean;
  mono?: boolean;
  capital?: boolean;
  bold?: boolean;
  contrast?: boolean;
  underline?: boolean;
  style?: CSSProperties;
  sx?: SxProps<Theme>;
  dangerouslySetInnerHTML?: any;
};

const Text = ({
  dangerouslySetInnerHTML,
  sx,
  small,
  medium,
  capital,
  underline,
  large,
  larger,
  normal,
  bold,
  children,
  contrast,
  numeric,
  mono,
  style,
}: TextProps) => {
  const classes = () => {
    const c = [];
    if (small) {
      c.push("small");
    } else if (medium) {
      c.push("medium");
    } else if (large) {
      c.push("large");
    } else if (larger) {
      c.push("larger");
    }
    if (bold) {
      c.push("bold");
    }
    if (contrast) {
      c.push("contrast");
    }
    if (underline) {
      c.push("underline");
    }
    if (numeric || mono) {
      c.push("mono");
    } else if (normal) {
      c.push("normal");
    }
    if (capital) {
      c.push("capitalised");
    }
    return c.join(" ");
  };
  return (
    <_Text sx={sx} style={style} className={classes()} dangerouslySetInnerHTML={dangerouslySetInnerHTML}>
      {children}
    </_Text>
  );
};

const _Text = styled("span")`
  margin: 0;
  display: flex;
  align-items: baseline;

  &.capitalised {
    text-transform: uppercase;
  }

  &.underline {
    text-decoration: underline;
  }

  &.contrast {
    font-weight: 500;
  }

  &.bold {
    font-weight: 600;
  }

  &.mono {
    font-family: IBM Mono, monospace;
  }

  &.normal {
    font-family: Inter, sans-serif;
  }

  &.small {
    font-size: 12px;

    @media (max-width: 992px) {
      font-size: 10px;
    }
  }

  &.medium {
    font-size: 16px;

    @media (max-width: 992px) {
      font-size: 14px;
    }
  }

  &.larger {
    font-size: 18px;

    @media (max-width: 992px) {
      font-size: 16px;
    }
  }

  &.large {
    font-size: 26px;
    @media (max-width: 992px) {
      font-size: 18px;
    }
  }
`;

const ActionBtn = (props: ButtonProps) => {

  return <_Button {...props} />;
};

const _Button = styled(Button)`
  font-weight: 400;

  &:hover {
    border: none;
  }
`;

export { Text, ActionBtn };
